import Node from 'nanogl-node'

import { CollectibleEntity, CollectStatus } from '@/webgl/runner/entities/CollectibleEntity'
import { ShoppingMode } from '@/webgl/runner/entities/ShoppingEntity'
import GameWorld from '@/webgl/runner/GameWorld'
import { AudioSegment } from '@/webgl/runner/scenarios/segments/AudioSegment'
import { PlaySegment } from '@/webgl/runner/scenarios/segments/PlaySegment'
import ShoppingBalanceTrack from '@/webgl/runner/scenarios/tracks/ShoppingBalanceTrack'

function createDummyEntity(world: GameWorld) {
  const ids = ['apples', 'brocoli', 'can', 'carrot', 'cereal', 'cherries', 'jam', 'milk', 'sardines']

  const id = ids[Math.floor(Math.random() * ids.length)]
  const data = world.registry.collectibles.get(id)

  let price = undefined
  if (data.prices && data.prices.length > 0) {
    // price = data.prices[Math.floor(Math.random() * data.prices.length)];
    price = Math.floor(Math.random() * data.prices.length)
  }

  let variant = undefined
  if (data.variants && data.variants.length > 0) {
    variant = data.variants[Math.floor(Math.random() * data.variants.length)]
  }

  const uuid = crypto.randomUUID()

  const entity: CollectibleEntity = {
    node: new Node(),
    uuid,
    y: 0,
    scale: 0.4,
    lane: 0,
    seed: Math.random(),
    spawntime: world.time.unscaledTime,
    lifetime: 0,
    releasing: false,
    collected: false,
    collectedTime: 0,
    collectStatus: CollectStatus.Neutral,
    highlight: false,
    data,
    switch: null,
    blur: 0,
    variant,
    priceID: price,
  }

  return entity
}

function setupWalletCart(world: GameWorld) {
  const padding = 30
  const shopping = world.shopping
  shopping.setMode(ShoppingMode.Balance)

  let cartPrice = shopping.state.cartValue

  if (shopping.state.cart.length < padding) {
    for (let i = shopping.state.cart.length; i < padding; i++) {
      const entity = createDummyEntity(world)
      cartPrice += entity.data.prices[entity.priceID]
      shopping.addToCart(entity)
    }
  }

  // shopping.setWallet(Math.floor(((cartPrice * 1000 / 3) / 1000)));
}

export class ShoppingCartSegment extends PlaySegment {
  DCR_VALUE = 0.25

  OnCollectibleGrabbed(collectible: CollectibleEntity): void {
    this.world.shopping.addToCart(collectible)
  }
}

export class ShoppingBalanceTransition extends AudioSegment {
  start(): void {
    super.start()
    setupWalletCart(this.world)
  }
}

export class ShoppingBalanceSegment extends PlaySegment {
  balanceTrack: ShoppingBalanceTrack
  brainFreezed: boolean = false
  breathSpawned: boolean = false

  start(): void {
    super.start()

    setupWalletCart(this.world)
    const shopping = this.world.shopping
    this.balanceTrack = this.track = new ShoppingBalanceTrack(this.world, shopping.state.cart)
    this.grabbedCount = 0
  }

  isCompleteConditionMet() {
    return false
  }

  OnCollectibleGrabbed(collectible: CollectibleEntity): void {
    this.world.shopping.removeFromCart(collectible)

    const gcount = this.grabbedCount

    const startPhase = gcount < 2
    if (startPhase) {
      this.spawnedCount = 0
      this.balanceTrack.injectBarrier('price')
    }

    const phonePhase = gcount == 6 || (!startPhase && gcount < 6 && this.spawnedCount > 30)
    if (phonePhase) {
      this.balanceTrack.injectBarrier('phone_calculator')
      this.spawnedCount = 0
    }

    // const deepBreath = !startPhase && gcount > 7 && gcount < 13 && Math.random() < 0.85;
    const deepBreath = !startPhase && gcount > 9 && gcount < 13 && !this.breathSpawned
    if (deepBreath) {
      this.breathSpawned = true
      this.balanceTrack.injectBarrier('deep_breath')
    }

    const brainPhase = !this.brainFreezed && (gcount >= 13 || (!startPhase && this.spawnedCount > 30))
    if (brainPhase) {
      this.brainFreezed = true
      this.balanceTrack.injectBarrier('brain_freeze')
      this.spawnedCount = 0
    }

    const walletBalance = this.world.shopping.state.walletValue - this.world.shopping.state.cartValue
    const end = !brainPhase && walletBalance >= 15
    if (end) {
      this.onComplete.emit()
    }
  }
}
